<p-toast></p-toast>
<p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog>
<p-tabView  [scrollable]="true" >
    <p-tabPanel header="Informations Générales">
        <form [formGroup]="formUser" (ngSubmit)="onGetUserInfos()">
            <div class="grid formgrid">
                <div class="col-12 md:col-6 mb-3 field p-fluid">
                    <label>Nom</label>
                    <input name="nom" formControlName="nom"
                           [class]="formUser.get('nom')?.invalid ? 'ng-dirty ng-invalid' : ''"
                           type="text" pInputText placeholder="Nom"/>
                </div>
        
                <div class="col-12 md:col-6 mb-3 field p-fluid">
                    <label>Prénom(s)</label>
                    <input name="prenom" formControlName="prenom"
                           [class]="formUser.get('prenom')?.invalid ? 'ng-dirty ng-invalid' : ''"
                           type="text" pInputText placeholder="prenom"/>
                </div>
        
                <div class="col-12 md:col-6 mb-3 field p-fluid">
                    <label>Téléphone</label>
                    <input name="telephone" formControlName="telephone"
                           [class]="formUser.get('telephone')?.invalid ? 'ng-dirty ng-invalid' : ''"
                           type="tel" pInputText placeholder="Ex:70000000"/>
                </div>
        
                <div class="col-12 md:col-6 mb-3 field p-fluid">
                    <label>Email</label>
                    <input [disabled]="true" name="email" formControlName="email" type="email" pInputText placeholder="Email" [readonly]="true"/>
                </div>
            </div>
        
            <div class="text-right mt-3">
                <button pButton pRipple type="reset" (click)="onCloseModal()" label="Annuler" class="p-button-outlined p-button-danger mr-3"></button>
                <button [disabled]="formUser.invalid" pButton pRipple type="submit" label="Enregistrer" class="p-button-outlined p-button-success"></button>
            </div>
        </form>
    </p-tabPanel>
    <p-tabPanel header="Mot de Passe">
        <form #passForm="ngForm" (ngSubmit)="updatePassword()" >
        <div class="grid formgrid">
        <div class="col-12 md:col-6 mb-3 field p-fluid">
            <label>Ancien mot de passe</label>
            <input required name="password" [(ngModel)]="passwordUpdated.currentPassword" type="text" pInputText placeholder="Mot de passe"/>
        </div>
        <div class="col-12 md:col-6 mb-3 field p-fluid">
            <label>Nouveau mot de passe</label>
            <input required name="password" [(ngModel)]="passwordUpdated.newPassword" type="text" pInputText placeholder="Mot de passe"/>
        </div>
        <div class="col-12 md:col-6 mb-3 field p-fluid">
            <label>Confirmer le nouveau mot de passe</label>
            <input  required name="repassword" [(ngModel)]="confirmPass" type="text" pInputText placeholder="Confirmer mot de passe" />
        </div>

        </div>
        <div class="text-right mt-3">
            <button pButton pRipple type="reset" (click)="onCloseModal()" label="Annuler" class="p-button-outlined p-button-danger mr-3"></button>
            <button [disabled]="passForm.invalid" pButton pRipple type="submit" label="Modifier le mot de passe" class="p-button-outlined p-button-success"></button>
        </div>
        </form>
    </p-tabPanel>
</p-tabView>
   
  




